module.exports = __webpack_public_path__ + "img/logo-gray.3bc1b08.png";